<template>
  <div class="not-found">
    <span class="not-found__code">404</span>
    <span class="not-found__title">Página não encontrada</span>
    <span class="not-found__message"
      >O link que você acessou é inválido ou não existe.</span
    >
  </div>
</template>

<style lang="scss" scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  gap: 0.8rem;
  text-align: center;

  &__code {
    font-size: 4rem;
    font-weight: bold;
    color: var(--color-primary, #333);
  }

  &__title {
    font-size: 1.2rem;
    font-weight: 600;
  }

  &__message {
    font-size: 0.9rem;
    color: #666;
  }
}
</style>
